import { render } from "./HeroiconsOutlineStatusOnline.vue?vue&type=template&id=53f85792"
const script = {}

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineStatusOnline.vue"]])

export default __exports__